import { withInstall } from '../../utils/install';
import Circular from './circular.vue';

export const IvueCircular = withInstall(Circular);
export default IvueCircular;

export * from './circular.vue';
